import common from '../common';

export function translate(key) {
	let str = key || '';
	if (str.length > 0) {
		const split = str.split('.');
		split.push(common.config.language || 'en');
		let i, length, t = common.config.strings;
		for (i = 0, length = split.length; i < length; ++i) {
			t = t[split[i]];
			if (!t) break;
		}
		i === split.length && (str = t);
	}
	return str;
}

(function () {
	PIXI.Text.prototype.renderWebGL = function (renderer) {
		if (!this.resolution) {
			this.resolution = renderer.resolution;
			this.dirty = true;
		}
		this.updateText(true);
		PIXI.Sprite.prototype.renderWebGL.call(this, renderer);
	};
})();